(function() {

    'use strict';



    // http://stackoverflow.com/questions/10964966/detect-ie-version-in-javascript
    var getIEVersion = function() {
        var nav = navigator.userAgent.toLowerCase();
        return (nav.indexOf('msie') !== -1) ? parseInt(nav.split('msie')[1]) : NaN;
    };

    /*var js = function(o) {
        return JSON.stringify(o);
    };*/



    var AdWrapperHtml5 = function(o) {
        /*jshint maxcomplexity:30 */
        var markup = ['<script type="text/javascript" src="', o.adURL ,'"></scr', 'ipt>'].join('');
        //var markup = ['<!DOCTYPE html><html><head></head><body><script type="text/javascript" src="', o.adURL ,'"></scr', 'ipt></body></html>'].join('');

        if (!o.viewMode) {
            o.viewMode = 'normal';
        }

        if (!o.desiredBitrate) {
            o.desiredBitrate = 4000;
        }

        if (!o.creativeData) {
            o.creativeData = {};
        }

        if (!o.environmentVars) {
            o.environmentVars = {};
        }


        var setIframeDims = function(w, h) {
            iframeEl.setAttribute('width',  w);
            iframeEl.setAttribute('height', h);
        };


        // create the iframe
        var iframeEl = document.createElement('iframe');
        var s = iframeEl.style;
        s.border = 0;
        iframeEl.setAttribute('frameBorder',           '0');
        iframeEl.setAttribute('scrolling',             'no');
        iframeEl.setAttribute('allowfullscreen',       '');
        iframeEl.setAttribute('mozallowfullscreen',    '');
        iframeEl.setAttribute('webkitallowfullscreen', '');

        if (!o.container) { o.container = document.body; }
        o.container.appendChild(iframeEl);

        var iframeWin = iframeEl.contentWindow;

        if (getIEVersion() < 10) { // one of IE's marvelous code gems (thx Cláudio Gamboa)...
            /*jshint scripturl:true*/
            iframeWin.contents = markup;
            iframeEl.src = 'javascript:window["contents"]';
        }
        else { //window.addEventListener) {
            iframeWin.document.open('text/html', 'replace');
            iframeWin.document.write(markup);
            iframeWin.document.close();
        }


        // VPAID 1.0
        var events = 'AdClickThru AdError AdExpandedChange AdImpression AdLinearChange AdLoaded AdLog AdPaused AdPlaying AdRemainingTimeChange AdStarted AdStopped AdUserAcceptInvitation AdUserClose AdUserMinimize AdVideoComplete AdVideoFirstQuartile AdVideoMidpoint AdVideoStart AdVideoThirdQuartile AdVolumeChange';
        // VPAID 2.0
        events += 'AdDurationChange AdInteraction AdSizeChange AdSkipped AdSkippableStateChange';
        events = events.split(' ');

        var ad;



        var onEvent = function(ev) {
            //console.log('**onEvent: ' + JSON.stringify(ev));

            switch (ev.type) {
                case 'AdLoaded':
                    ad.startAd();
                    break;

                case 'AdSizeChange': // TODO REPLICATE IN AS
                    (function() {
                        var w = ad.getAdWidth();
                        var h = ad.getAdHeight();
                        setIframeDims(w, h);
                    })();
                    break;
            }
        };



        // bind stuff
        var getReadyInterval;
        var getReady = function() {
            var fn = iframeWin.getVPAIDAd;
            if (!fn || typeof fn !== 'function') { return; }
            clearInterval(getReadyInterval);

            ad = fn();

            ad.subscribeSane = function(evName, cb, ctx) { // HELPERS
                this.subscribe(cb, evName, ctx);
            };

            ad.unsubscribeSane = function(evName, cb) {
                this.unsubscribe(cb, evName);
            };

            //console.log('X', o);
            if ('onReady' in o) {
                o.onReady(ad);
            }

            for (var i = 0, I = events.length; i < I; ++i) {
                ad.subscribe(onEvent, events[i]);
            }

            //console.log('handshakeVersion("2.0") -> ' + js(ad.handshakeVersion('2.0')) );
            ad.handshakeVersion('2.0');

            ad.initAd(o.adDims[0], o.adDims[1], o.viewMode, o.creativeData, o.environmentVars); // hardcoded
            setIframeDims(o.adDims[0], o.adDims[1]);
        };
        getReadyInterval = setInterval(getReady, 100);
    };

    SAPO.Project.Video.VAST.VPAID.AdWrapperHtml5 = AdWrapperHtml5;

})();
